import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiNavigation' })(
  ({ breakpoints, brandColors, brandType, type, typography }) => ({
    drawer: {
      width: '100%',
      height: '100%',
      backgroundColor: brandColors.offWhite,
      '& .headerElementsWrapper': {
        display: 'flex',
        padding: `${typography.pxToRem(24)}`,
        [breakpoints.up(ScreenSize.MEDIUM)]: {
          padding: `${typography.pxToRem(24)} ${typography.pxToRem(40)}`,
        },
        textAlign: 'right',
        '& svg': {
          color: brandColors.primaryMain,
        },
      },
      '& .sidebarWrapper': {
        '& .sidemenuWrapper': {
          '& .sidebarMenu': {
            ...type['24_medium'],
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            padding: `${typography.pxToRem(16)} ${typography.pxToRem(40)}`,
            [breakpoints.down(ScreenSize.MEDIUM)]: {
              padding: `${typography.pxToRem(12)} ${typography.pxToRem(24)}`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'baseline',
            },
            color: brandColors.primaryMain,
            '& p': {
              margin: 0,
            },
            '& .active': {
              backgroundColor: brandColors.primaryMain,
            },
          },
        },
        '& .footer': {
          color: brandColors.primaryMain,
          position: 'absolute',
          bottom: typography.pxToRem(64),
          left: typography.pxToRem(24),
          fontWeight: brandType['body-s'].fontWeight,
          lineHeight: brandType['body-s'].lineHeight,
          letterSpacing: brandType['body-s'].letterSpacing,
          fontSize: typography.pxToRem(14), // This font in the Figma does not adhere to the type style.
          [breakpoints.up(ScreenSize.MEDIUM)]: {
            fontWeight: type['16_medium'].fontWeight,
            lineHeight: type['16_medium'].lineHeight,
            letterSpacing: type['16_medium'].letterSpacing,
            fontSize: type['16_medium'].fontSize as string,
          },
        },
      },
    },
    logo: { margin: `${typography.pxToRem(12)} ${typography.pxToRem(5)}` },
    closeIcon: {
      background: 'transparent',
      cursor: 'pointer',
      border: 'none',
      position: 'absolute',
      right: typography.pxToRem(24),
      top: typography.pxToRem(24),
    },
    menuItem: {
      '& .MuiPaper-root': {
        width: 150,
      },
    },
    item: {
      marginBottom: typography.pxToRem(16),
      width: '100%',
    },
  })
);

export default useStyles;
